(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('EgsDetailController', EgsDetailController);

    EgsDetailController.$inject = ['$stateParams', 'EventCollections',  'EGSService', '$uibModalInstance'];

    function EgsDetailController($stateParams, EventCollections,  EGSService, $uibModalInstance) {

        var vm = this;


        /**** Properties ****/
        vm.waiting = true;
        vm.showLog = false;
        vm.egsJob = null;
        vm.spec = null;
        vm.egsParameters = null;

        /**** Methods ****/
        vm.clear = clear;
        vm.displayDate = displayDate;
        vm.jobsStatusClass = EGSService.jobsStatusClass;

        //Load the EventCollection
        EventCollections.getEventCollection($stateParams.id, init, showError);

        function init(response) {
            vm.eventCollection= response.data;
            vm.egsJob = vm.eventCollection.egsJob;
            vm.spec = vm.eventCollection.egsJob.spec;
            vm.egsParameters = vm.spec.egsParameters;
            vm.waiting = false;
        }

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                $scope.$apply();
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function displayDate(date) {
            var display = date.startDate + " - ";
            display += date.endDate ;
            return display;
        }

    }
})();
